module.exports = __webpack_public_path__ + "b8c497b4e2b5f5976199a46063613ccd.svg";